import React from 'react';
import { connect } from 'react-redux';
import { Icon, Spin, Switch, Table } from 'antd';
import * as _ from 'lodash';
import style from "./list.module.sass";
import { AppState } from '../../../../stateManager/store';
import { pushToast } from '../../../../stateManager/store/toast/actions'
import { Http } from '../../../../helpers/axois';
import { Button, Modal } from '../../../../helpers/commonUi'
import serviceImg from '../../../../assets/images/create_service.svg';
import NoData from '../../NoData'
import Configuration from './Configuration';
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { getRandomId } from '../../../../utils/random-id';


interface State {
    visible: boolean;
    editInitialData?: {};
    configList?: any[];
    editable: boolean;
    editvisible?: boolean;
    loading?: boolean;
    deleteVisible: boolean;
    deleteData: any
}

interface Props {
    match?: any;
    app?: any;
    history?: any;
    deleteService: (data: any) => void;
    appVersion?: { currentVersion: boolean, versionId: string }
    pushToast: (data: any) => void;
    orgPermissions: any;
    appPermissions: any;
    currentBranch?: any;
}

class ConfigList extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            visible: false,
            editInitialData: {},
            editable: false,
            configList: [],
            editvisible: false,
            loading: false,
            deleteVisible: false,
            deleteData: {}
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        this.versionUpdate(this.props);
    }

    componentWillReceiveProps(props: Props) {
        if (props.appVersion !== this.props.appVersion) {
            this.versionUpdate(props);
        }
    }

    visibleChange(data: any) {
        const state = _.cloneDeep(this.state.configList);
        const findIndex = _.findIndex(state, ['configId', data.configId]);
        if (findIndex > -1 && state && state[findIndex]) {
            state[findIndex]['visible'] = !data.visible;
        }
        this.setState({
            configList: state
        })
    }

    updateConfig(configId: string, dataObject: any) {
        const versionId = this.props.appVersion && this.props.appVersion.versionId;
        const appId = this.props.match.params.appId
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
        const data = {
            ...dataObject,
            appId: appId,
            versionId: versionId,
            branchId: currentBranchId
        }
        Http.put(`app/${appId}/config/${configId}`, data).subscribe(() => {
            // this.props.pushToast(
            //     { type: 'success', message: 'Config updated successfully' }
            // )
            this.getConfigs(this.props)
        }, (err) => {
            this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : "Config Updataion failed" }
            )
        })
    }

    versionUpdate(props: Props) {
        const version = props.appVersion;
        if (version) {
            this.getConfigs(props)
        }
    }
    getConfigs(props: Props) {
        const version = props.appVersion && props.appVersion.versionId;
        const appId = this.props.match.params.appId
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
        Http.get(`/app/${appId}/config?versionId=${version}&branchId=${currentBranchId}`).subscribe((configRes: any) => {
            this.setState({
                configList: configRes.map((o: any) => { return { ...o, key_: o.key, visible: false } }),
                loading: false
            })
        });
    }

    deleteconfig(configId: string) {
        const appId = this.props.match.params.appId
        const versionId = this.props.appVersion && this.props.appVersion.versionId;
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
        Http.delete(`app/${appId}/config/${configId}?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((res) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'success', message: 'Config deleted successfully' }
            )
            this.getConfigs(this.props);
        }, (err) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'Config deletion failed' }
            )
        })
    }

    render() {
        const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
        const canCreateConfig = currentVersion && (this.props.orgPermissions.includes('config.Create') || this.props.appPermissions.includes('config.Create'))
        const canEditConfig = currentVersion && (this.props.orgPermissions.includes('config.Edit') || this.props.appPermissions.includes('config.Edit'))
        const canDeleteConfig = currentVersion && (this.props.orgPermissions.includes('config.Delete') || this.props.appPermissions.includes('config.Delete'))
        const canViewConfig = this.props.orgPermissions.includes('config.View') || this.props.appPermissions.includes('config.View')

        const columns: any = [
            {
                title: "Key",
                dataIndex: "key_",
                // key: "key_"
                key: getRandomId()
            },
            {
                title: "Value",
                dataIndex: "value",
                // key: "value",
                key: getRandomId(),

                render: (text: string, record: any) => {

                    if (text == null) {
                        text = ""
                    }

                    if (text.length > 10) {
                        text = text.substring(0, 10) + '...'
                    }

                    return (
                        <div className={style.valueColumn}>
                            {(record.visible) ? <span>{text}</span> : <span className={style.dotspan}>
                                {text.split('').slice(0, 10).map((o, index) => <div key={index} className={style.dot}></div>)}
                            </span>
                            }
                            {text.length <= 0 ? <Icon style={{ visibility: "hidden" }} type="hide"></Icon> : (record.visible) ? <Icon className={style.eyeIcon} data-test-id="config_eye_icon" type="eye" onClick={(e: any) => this.visibleChange(record)} /> : <Icon className={style.eyeIcon} data-test-id="config_eye_invisible" type="eye-invisible" onClick={(e: any) => this.visibleChange(record)} />}
                        </div>);
                }
            },
            {
                title: "Required",
                dataIndex: "required",
                key: getRandomId(),
                render: (text: any, record: any) => (
                    <Switch data-test-id="config_switch_required" disabled={!(canEditConfig)} defaultChecked={record.required} onChange={(e) => {
                        this.updateConfig(record.configId, { required: e })
                    }} />
                )
            },
            {
                title: "Protected",
                dataIndex: "protected",
                key: getRandomId(),
                render: (text: any, record: any) => (
                    <Switch data-test-id="config_switch_protected" disabled={!(canEditConfig)} defaultChecked={record.protected} onChange={(e) => {
                        this.updateConfig(record.configId, { protected: e })
                    }} />
                )
            },
            {
                title: "Public",
                dataIndex: "public",
                key: getRandomId(),
                render: (text: any, record: any) => (
                    <Switch data-test-id="config_switch_public" disabled={!(canEditConfig)} defaultChecked={record.isPublic} onChange={(e) => {
                        this.updateConfig(record.configId, { isPublic: e })
                    }} />
                )
            },
            {
                title: "Make it Available for client",
                dataIndex: "visibleClient",
                key: getRandomId(),
                render: (text: any, record: any) => {
                    return (
                        <Switch data-test-id="config_switch_visible" disabled={!(canEditConfig)} defaultChecked={record.visibleClient} onChange={(e) => {
                            this.updateConfig(record.configId, { visibleClient: e })
                        }} />
                    )
                }
            }
        ];

        if (currentVersion) {
            columns.push(
                {
                    title: "Action",
                    key: "action",
                    render: (text: any, record: any) => (
                        <div className="action">
                            <span
                                data-test-id="action_edit"
                                title="Edit"
                                className="action-icon edit-icon"
                                onClick={e => {
                                    e.stopPropagation();
                                    if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                                        this.props.pushToast({
                                            type: 'error',
                                            message: 'Cannot modify a previous app version'
                                        })
                                        return
                                    }
                                    if (canEditConfig) {
                                        this.setState({
                                            editvisible: true,
                                            editInitialData: { ...record, key: record.key_ },
                                            editable: true
                                        });
                                    } else {
                                        this.props.pushToast({
                                            type: 'error',
                                            message: 'You are not authorized to edit this config'
                                        })
                                    }
                                }}
                            >
                                <TableEdit height='15px' width='15px' />
                            </span>
                            {this.state.configList!.length >= 1 && (
                                <span
                                    data-test-id="action_delete"
                                    className="action-icon delete-icon"
                                    title="Delete"
                                    onClick={e => {
                                        e.stopPropagation();
                                        if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                                            this.props.pushToast({
                                                type: 'error',
                                                message: 'Cannot modify a previous app version'
                                            })
                                            return
                                        }
                                        if (canDeleteConfig) {
                                            this.setState({
                                                deleteVisible: true,
                                                deleteData: { ...record, key: record.key_ }
                                            })
                                        } else {
                                            this.props.pushToast({
                                                type: 'error',
                                                message: 'You are not authorized to delete this config'
                                            })
                                        }
                                    }}
                                >
                                    <Delete />
                                </span>
                            )}
                        </div>
                    )
                }
            )
        }

        const appId = this.props.match.params.appId
        const versionId = this.props.appVersion && this.props.appVersion.versionId
        const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />

        return (
            canViewConfig ?
                <div className='viewWrapper'>
                    {
                        !this.state.loading && this.state.configList && this.state.configList.length > 0
                            ?
                            <div className={"row " + style.data}>
                                <div className={style.header}>
                                    <div className={style.first}>
                                        <h4>Configuration</h4>
                                        <h5>View, edit or create a new variable</h5>
                                    </div>
                                    {
                                        canCreateConfig &&
                                        (
                                            <Button dataTestId="add_variable" size="small" onClick={() => this.setState({ visible: true })}>
                                                ADD VARIABLE
                                            </Button>
                                        )
                                    }
                                </div>
                                <div className={style.content}>
                                    <Table
                                        data-test-id="config_table"
                                        pagination={false}
                                        scroll={{ y: 'calc(100vh - 240px)' }}
                                        columns={columns}
                                        className={"override-table-container"}
                                        dataSource={this.state.configList!.map((res) => {
                                            return { ...res, key: res.configId };
                                        })}
                                    />
                                </div>
                            </div>
                            :
                            (this.state.loading)
                                ?
                                <div className={style.loadingSpinner}>
                                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                                </div>
                                :
                                <NoData
                                    image={serviceImg}
                                    header='Create Configuration'
                                    content='Create configuration for your apps'
                                    // buttonText='Create new version'
                                    buttonCallback={() => (canCreateConfig) ? this.setState({ visible: true }) : this.props.pushToast({
                                        type: 'error',
                                        message: 'You are not authorized to create configurations'
                                    })}
                                />
                    }

                    <ConfigModal
                        data-test-id="config_modal_1"
                        key={1}
                        visible={this.state.visible}
                        getConfigs={() => this.getConfigs(this.props)}
                        appId={appId}
                        versionId={versionId}
                        setvisible={status => this.setState({ visible: status })}
                    ></ConfigModal>
                    {this.state.editvisible && (
                        <ConfigModal
                            data-test-id="config_modal_2"
                            key={2}
                            versionId={versionId}
                            getConfigs={() => this.getConfigs(this.props)}
                            visible={this.state.editable}
                            editInitialData={this.state.editInitialData}
                            appId={appId}
                            setvisible={status => {
                                this.setState({ editable: status, editInitialData: {} });
                                setTimeout(() => {
                                    this.setState({ editvisible: false });
                                }, 400);
                            }}
                            editable={this.state.editable}
                        ></ConfigModal>
                    )}
                    <Modal
                        dataTestId="delete_variable"
                        id="deleteVariable"
                        unmountOnCancel={true}
                        visible={this.state.deleteVisible}
                        title="DELETE VARIABLE"
                        onCancel={() => {
                            this.setState({
                                deleteVisible: false,
                                deleteData: {}
                            })
                        }}
                        deleteOptions={{
                            type: "VARIABLE",
                            validateString: this.state.deleteData.key_
                        }}
                        footer={{
                            enable: true,
                            okText: 'DELETE',
                            cancelText: 'CANCEL',
                            onOk: () => {
                                this.deleteconfig(this.state.deleteData.configId)
                                this.setState({
                                    deleteVisible: false
                                })
                            }
                        }}
                    />
                </div>
                :
                <div className="viewWrapper">
                    <NoData
                        svg={WarningIcon}
                        header='Not Authorized'
                        content='Please request owner of this organization to provide access'
                        noButton={true}
                    />
                </div>
        );
    }
}


interface ConfigModalProps {
    visible: boolean;
    getConfigs: () => void;
    setvisible: (status: boolean) => void;
    appId: any;
    versionId: any;
    editInitialData?: {};
    editable?: boolean;
}
let onSubmit: any;
const ConfigModal = ({
    visible,
    getConfigs,
    setvisible,
    appId,
    versionId,
    editInitialData,
    editable
}: ConfigModalProps) => {
    return (
        <Modal
            id="createEditVariable"
            dataTestId="create_edit_variable"
            title={editInitialData ? 'EDIT VARIABLE' : 'CREATE VARIABLE'}
            visible={visible}
            onCancel={() => {
                setvisible(false);
            }}
            unmountOnCancel={true}
            footer={{
                enable: true,
                okText: editable ? "SAVE" : "CREATE",
                cancelText: "CANCEL",
                onOk: () => {
                    onSubmit(setvisible);
                }
            }}
        >
            <Configuration
                data-test-id="config_modal"
                versionId={versionId}
                appId={appId}
                getConfigs={getConfigs}
                editInitialData={editInitialData}
                onSubmit={(submit: any) => (onSubmit = submit)}
                editable={editable}
            ></Configuration>
        </Modal>
    );
};
const mapStateToProps = (state: AppState, props: Props) => {
    const params: any = props.match.params;
    return {
        appVersion: state.apps.appVersion[params['appId']],
        orgPermissions: state.org.orgPermissions,
        appPermissions: state.apps.selectedApp.permissions,
        currentBranch: state.apps.appBranch
    }
};


export default connect(mapStateToProps, { pushToast })(ConfigList);
